import React from 'react';

import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

const SUPPLIER_STATE_OPTIONS = [
  { value: 'bedbankTrue', label: 'Bedbank: True' },
  { value: 'bedbankFalse', label: 'Bedbank: False' },
  { value: 'lpcTrue', label: 'LPC: True' },
  { value: 'lpcFalse', label: 'LPC: False' },
  { value: 'flashTrue', label: 'Flash: True' },
  { value: 'flashFalse', label: 'Flash: False' },
] as const;

interface Props {
  value: string;
  onChange: (newValue: string) => void;
}

export default function AccommodationSupplierStateFilterInput({ value, onChange }: Props) {
  const selected = value ? value.split(',') : [];

  return (
    <FormControl fullWidth>
      <InputLabel id="supplier-state-label">Supplier state</InputLabel>
      <Select<Array<string>>
        labelId="supplier-state-label"
        label="Supplier state"
        multiple
        value={selected}
        onChange={(e) => {
          const next = e.target.value as Array<string>;
          onChange(next.filter(Boolean).join(','));
        }}
        renderValue={(s: Array<string>) =>
          s.length === 0
            ? 'All'
            : s.map((token) => SUPPLIER_STATE_OPTIONS.find((o) => o.value === token)?.label ?? token).join(', ')
        }
      >
        {SUPPLIER_STATE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selected.includes(option.value)} size="small" />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
